import { render, staticRenderFns } from "./returnMaterial.vue?vue&type=template&id=1d20ef6f&scoped=true"
import script from "./returnMaterial.vue?vue&type=script&lang=js"
export * from "./returnMaterial.vue?vue&type=script&lang=js"
import style0 from "./returnMaterial.vue?vue&type=style&index=0&id=1d20ef6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20ef6f",
  null
  
)

export default component.exports